import { InputAdornment, IconButton } from '@mui/material'
import { Close } from '@mui/icons-material'
import React from 'react'
import { func } from 'prop-types'
export default function SearchEndAdornment({ action }) {
  return (
    <InputAdornment position="start">
      <IconButton
        color="white"
        sx={{ marginBottom: '3px' }}
        onClick={() => action()}
      >
        <Close />
      </IconButton>
    </InputAdornment>
  )
}

SearchEndAdornment.propTypes = {
  action: func
}
